/* tslint:disable */
/* eslint-disable */
/**
 * Employees API
 * API to get company clients employees
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyClientReviewLabelOfEmployee,
    CompanyClientReviewLabelOfEmployeeFromJSON,
    CompanyClientReviewLabelOfEmployeeFromJSONTyped,
    CompanyClientReviewLabelOfEmployeeToJSON,
} from './CompanyClientReviewLabelOfEmployee';

/**
 * 
 * @export
 * @interface CompanyClientEmployeeSimpleReviewResponse
 */
export interface CompanyClientEmployeeSimpleReviewResponse {
    /**
     * The ID of review record
     * @type {number}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    reviewId?: number;
    /**
     * Review score of this employee
     * @type {number}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    reviewScore: number;
    /**
     * Shift's gig name
     * @type {string}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    gigName: string;
    /**
     * Shift ID for which the review is given
     * @type {number}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    shiftId: number;
    /**
     * Time when shift starts
     * @type {Date}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    shiftStartTimestamp: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    dateCreated?: Date;
    /**
     * Already chosen labels for this review
     * @type {Array<CompanyClientReviewLabelOfEmployee>}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    labels: Array<CompanyClientReviewLabelOfEmployee>;
    /**
     * Employee ID
     * @type {number}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    employeeId?: number;
    /**
     * Additional notes after on review
     * @type {string}
     * @memberof CompanyClientEmployeeSimpleReviewResponse
     */
    note?: string;
}

export function CompanyClientEmployeeSimpleReviewResponseFromJSON(json: any): CompanyClientEmployeeSimpleReviewResponse {
    return CompanyClientEmployeeSimpleReviewResponseFromJSONTyped(json, false);
}

export function CompanyClientEmployeeSimpleReviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyClientEmployeeSimpleReviewResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reviewId': !exists(json, 'reviewId') ? undefined : json['reviewId'],
        'reviewScore': json['reviewScore'],
        'gigName': json['gigName'],
        'shiftId': json['shiftId'],
        'shiftStartTimestamp': (new Date(json['shiftStartTimestamp'])),
        'dateCreated': !exists(json, 'dateCreated') ? undefined : (new Date(json['dateCreated'])),
        'labels': ((json['labels'] as Array<any>).map(CompanyClientReviewLabelOfEmployeeFromJSON)),
        'employeeId': !exists(json, 'employeeId') ? undefined : json['employeeId'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CompanyClientEmployeeSimpleReviewResponseToJSON(value?: CompanyClientEmployeeSimpleReviewResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reviewId': value.reviewId,
        'reviewScore': value.reviewScore,
        'gigName': value.gigName,
        'shiftId': value.shiftId,
        'shiftStartTimestamp': (value.shiftStartTimestamp.toISOString()),
        'dateCreated': value.dateCreated === undefined ? undefined : (value.dateCreated.toISOString()),
        'labels': ((value.labels as Array<any>).map(CompanyClientReviewLabelOfEmployeeToJSON)),
        'employeeId': value.employeeId,
        'note': value.note,
    };
}

